import Footer from '@/components/layout/footer';
import { NavbarCleaner } from '@/components/layout/navbar/navbar.cleaner';
import { ContactUs } from '@/features/consumer/contact-us';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(cleaner)/cleaner/contact-us')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div>
      <NavbarCleaner />
      <ContactUs />
      <Footer />
    </div>
  );
}
